// @ts-nocheck
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, RequestDataFromApi, props => {
    const availabilityCode = props.apiResult?.additionalResults?.["availabilityCode"];
    const availabilityDelayDays = props.apiResult?.additionalResults?.["availabilityDelayDays"];
    const additionnalMessage = props.apiResult?.additionalResults?.["availabilityMessage"];
    if (props.apiResult && props.apiResult.inventoryWarehousesDtos) {
        props.apiResult.inventoryAvailabilityDtos?.forEach(i => {
            if (i.availability) {
                i.availability.availabilityCode = availabilityCode;
                i.availability.availabilityDelayDays = availabilityDelayDays;
                i.availability.additionnalMessage = additionnalMessage;
            }
        });
    }
});
